import { render } from "./VerificationPage.vue?vue&type=template&id=ffa501b6&scoped=true"
import script from "./VerificationPage.vue?vue&type=script&lang=js"
export * from "./VerificationPage.vue?vue&type=script&lang=js"

import "./VerificationPage.vue?vue&type=style&index=0&id=ffa501b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffa501b6"]])

export default __exports__